import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DispatchTableHead from './TableHead';

class CaptainTable extends Component {
  handleOpenModal = captain => {
    const { handleOpenItemModal } = this.props;
    const content = this.modalContent(captain);
    handleOpenItemModal(content);
  };

  handleCloseModal = () => {
    const { handleCloseItemModal } = this.props;
    handleCloseItemModal();
  };

  modalContent = captain => {
    if (!captain) {
      return;
    }
    return (
      <div className="details">
        <div className="captain vc">
          <label className="control-label">Nom :</label>
          <p>{captain.name}</p>
        </div>
        <div className="captain vc">
          <label className="control-label">No :</label>
          <p>{captain.employee_number}</p>
        </div>
        <div className="captain vc">
          <label className="control-label">Courriel :</label>
          <p>{captain.email}</p>
        </div>
        <div className="captain vc">
          <label className="control-label">Note :</label>
          <p>{captain.note}</p>
        </div>
      </div>
    );
  };

  render() {
    const {
      captain,
      handleToggleItemModal,
      handleDeleteClick,
      copyType,
      handleCopy,
      handlePaste,
      userType,
    } = this.props;

    return (
      <div>
        <table className="captains">
          <DispatchTableHead
            numberOfItems={captain ? 1 : 0}
            title="Contremaitre"
            span={2}
            onAddClick={() => handleToggleItemModal(1)}
            active={copyType === 'captain_id'}
            userType={userType}
            onOptionClick={() =>
              copyType === 'captain_id' ? handlePaste() : handleCopy()
            }
          />
          <tbody>
            {captain ? (
              <tr>
                <td
                  onClick={() => this.handleOpenModal(captain)}
                  className={captain.note ? 'has_note' : ''}
                >
                  {captain.name}
                </td>
                {userType === 'admin' && (
                  <td
                    className="delete-icon"
                    onClick={() => handleDeleteClick(captain.id)}
                  >
                    <i className="fa fa-times" aria-hidden="true" />
                  </td>
                )}
              </tr>
            ) : (
              <tr className="empty">
                <td />
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

CaptainTable.propTypes = {
  employees: PropTypes.array,
  handleToggleItemModal: PropTypes.func,
  handleDeleteClick: PropTypes.func,
};

export default CaptainTable;
